import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { environment } from '@env/environment';
import { EnrollmentCourseFees } from '@lib/interfaces';
import { ProgramFees } from '@lib/interfaces/program.interface';
import { StudentApplicationFormState } from '@lib/interfaces/student-application-state-interfaces';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class StudentApplicationService {
    private readonly http = inject(HttpClient);
    private readonly baseUrl = environment.API_URL;

    /**
     * Gets program fees for a course
     * @param courseId The course ID
     * @returns Observable with the program fees data
     */
    getProgramFees(courseId: string): Observable<ProgramFees> {
        return this.http.get<ProgramFees>(`${this.baseUrl}/group-course/get-program-fees/${courseId}`);
    }

    getCourseFees(courseId: string): Observable<EnrollmentCourseFees[]> {
        return this.http.get<EnrollmentCourseFees[]>(`${this.baseUrl}/course/${courseId}/fees`);
    }

    getStudentApplicationInitialDetails(courseId: string): Observable<{ data: StudentApplicationFormState }> {
        return this.http.get<{ data: StudentApplicationFormState }>(
            `${this.baseUrl}/students/course/${courseId}/enrollment`,
        );
    }

    submitEnrollment(courseId: string, formData: FormData) {
        return this.http.post(`${this.baseUrl}/students/course/${courseId}/enrollment`, formData, {
            headers: {
                Accept: 'application/json',
            },
        });
    }
}
